const problems = [
  { icon: 'ri-emotion-unhappy-line', text: '空間不夠吸引人，進店率低落' },
  { icon: 'ri-route-line', text: '動線混亂，影響消費體驗與坪效' },
  { icon: 'ri-fingerprint-line', text: '品牌識別感薄弱，難以留下深刻印象' },
  { icon: 'ri-arrow-go-back-line', text: '老店翻新沒有方向，不知如何升級' },
  { icon: 'ri-file-list-3-line', text: '裝修流程繁瑣，找廠商壓力大' },
  { icon: 'ri-contrast-2-line', text: '設計圖與實際完工落差太大' },
];

export default function ProblemSection() {
  return (
    <section className="py-24 md:py-32 bg-[#1a1a1a] text-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-center gap-16 lg:gap-24">
          {/* Left */}
          <div className="lg:w-5/12">
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-4">Pain Points</p>
            <h2
              className="font-bold leading-[1.35] mb-6"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
            >
              我們能解決<br />
              <span
                className="font-display font-light italic text-[#d4b896]"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(1.75rem, 3.5vw, 2.5rem)' }}
              >
                這些商業空間困境
              </span>
            </h2>
            <p className="text-white/60 leading-relaxed mb-8" style={{ fontSize: '1.1875rem' }}>
              我們深知每位業主在開店或翻新時面臨的真實挑戰。
              心旅商研的服務模式，正是為了讓你少走彎路、精準落地。
            </p>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 border border-[#b8956a] text-[#b8956a] rounded-full font-medium hover:bg-[#b8956a] hover:text-white transition-colors duration-300 cursor-pointer whitespace-nowrap text-[1rem]"
            >
              免費諮詢你的狀況
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Right - Problem Grid */}
          <div className="lg:w-7/12 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {problems.map((p, i) => (
              <div
                key={i}
                className="flex items-start gap-4 p-6 rounded-2xl bg-white/5 border border-white/10"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#b8956a]/20 rounded-xl flex-shrink-0">
                  <i className={`${p.icon} text-[#b8956a] text-lg`}></i>
                </div>
                <p className="text-white/80 leading-relaxed" style={{ fontSize: '1rem' }}>{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
